import { useState, useEffect } from "react";
import { Phone, MessageCircle } from "lucide-react";
import { contactInfo } from "../mock";

const FloatingActions = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Desktop: schwebende Buttons (ab lg) */}
      <div
        className={`hidden lg:flex fixed left-4 bottom-4 z-[55] flex-col gap-3 transition-all duration-300 ${
          show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
        }`}
      >
        <a
          href={contactInfo.whatsappHref}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp"
          className="flex items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-green-600/30 hover:scale-105 transition-transform"
          style={{ width: 56, height: 56 }}
        >
          <MessageCircle className="w-6 h-6" fill="currentColor" strokeWidth={0} />
        </a>
        <a
          href={contactInfo.phoneHref}
          aria-label="Anrufen"
          className="flex items-center justify-center rounded-full bg-blue-600 text-white shadow-lg shadow-blue-600/30 hover:scale-105 transition-transform"
          style={{ width: 56, height: 56 }}
        >
          <Phone className="w-6 h-6" />
        </a>
      </div>

      {/* Mobil: feste Kontakt-Leiste unten (immer erreichbar) */}
      <div
        className="lg:hidden fixed inset-x-0 bottom-0 z-[55] bg-white/95 backdrop-blur-md border-t border-slate-200 px-3 py-2.5 flex gap-2.5"
        style={{ paddingBottom: "calc(0.625rem + env(safe-area-inset-bottom))" }}
        data-testid="mobile-cta-bar"
      >
        <a
          href={contactInfo.phoneHref}
          data-testid="mobile-cta-call"
          className="flex-1 inline-flex items-center justify-center gap-2 h-12 rounded-xl bg-blue-600 text-white text-[15px] font-semibold shadow-md shadow-blue-600/25 active:scale-[0.98] transition-transform"
        >
          <Phone className="w-5 h-5" /> Anrufen
        </a>
        <a
          href={contactInfo.whatsappHref}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-cta-whatsapp"
          className="flex-1 inline-flex items-center justify-center gap-2 h-12 rounded-xl bg-[#25D366] text-white text-[15px] font-semibold shadow-md shadow-green-600/25 active:scale-[0.98] transition-transform"
        >
          <MessageCircle className="w-5 h-5" fill="currentColor" strokeWidth={0} /> WhatsApp
        </a>
      </div>
    </>
  );
};

export default FloatingActions;
